(function () {

  const WP_UPLOAD_ENDPOINT = 'https://files.inyouths.com/wp-json/inyouths-upload/v1/file';
  const MAX_FILES = 10;         // 可上传最大数量
  const MAX_FILE_SIZE_MB = 100; // 单文件最大 100MB

  function initFileUploader(wrapper) {
    const nativeInput = wrapper.querySelector('[data-file-input]');
    const dropzone = wrapper.querySelector('[data-file-dropzone]');
    const triggerBtn = wrapper.querySelector('[data-file-trigger]');
    const listEl = wrapper.querySelector('[data-file-list]');
    const linksInput = wrapper.querySelector('[data-file-links-input]');
    const normalView = wrapper.querySelector('[data-dropzone-normal]');
    const limitView = wrapper.querySelector('[data-dropzone-limit]');
    const maxFileSizeMb = Number(wrapper.dataset.maxFileSizeMb) || MAX_FILE_SIZE_MB;

    if (!nativeInput || !dropzone || !triggerBtn || !listEl || !linksInput) return;

    let uploadedUrls = [];

    function updateLinksInput() {
      linksInput.value = uploadedUrls.join('\n');
    }

    function getCurrentCount() {
      return listEl.querySelectorAll('.file-item').length;
    }

    function updateDropzoneState() {
      const count = getCurrentCount();
      const limitReached = count >= MAX_FILES;

      if (limitReached) {
        dropzone.classList.add('file-dropzone--disabled');
        normalView.style.display = 'none';
        limitView.style.display = 'flex';
      } else {
        dropzone.classList.remove('file-dropzone--disabled');
        normalView.style.display = 'flex';
        limitView.style.display = 'none';
      }
    }

    function createThumbnail(file) {
      if (!file.type.startsWith('image/')) return '';
      return URL.createObjectURL(file);
    }

    function createListItem(file) {
      const li = document.createElement('li');
      li.className = 'file-item';

      const thumbUrl = createThumbnail(file);

      li.innerHTML = `
        <div class="file-item__main">
          <div class="file-item__left">
            <div class="file-item__thumb">
              ${
                thumbUrl
                  ? `<img src="${thumbUrl}" alt="${file.name}">`
                  : `<span class="file-item__thumb-placeholder"></span>`
              }
            </div>
            <div class="file-item__info">
              <span class="file-item__name">${file.name}</span>
              <span class="file-item__size">${(file.size / 1024 / 1024).toFixed(2)} MB</span>
            </div>
          </div>
          <div class="file-item__right">
            <button type="button" class="file-item__remove">&times;</button>
          </div>
        </div>

        <div class="file-item__progress">
          <div class="file-item__progress-bar"></div>
        </div>
      `;

      listEl.appendChild(li);
      updateDropzoneState();

      // 删除按钮
      li.querySelector('.file-item__remove').addEventListener('click', () => {
        const url = li.getAttribute('data-file-url');

        if (url) {
          uploadedUrls = uploadedUrls.filter((u) => u !== url);
          updateLinksInput();
        }

        li.remove();
        updateDropzoneState();
      });

      return li;
    }

    function setProgress(li, percent) {
      const bar = li.querySelector('.file-item__progress-bar');
      if (bar) bar.style.width = percent + '%';
    }

    function setStatus(li, state) {
      const nameEl = li.querySelector('.file-item__name');
      nameEl.classList.remove('is-uploading', 'is-success', 'is-error');

      if (state) nameEl.classList.add(state);
    }

    function uploadFile(file) {
      return new Promise((resolve, reject) => {
        const li = createListItem(file);

        if (file.size > maxFileSizeMb * 1024 * 1024) {
          setStatus(li, 'is-error');
          reject(new Error('File too large'));
          return;
        }

        setStatus(li, 'is-uploading');

        const xhr = new XMLHttpRequest();
        xhr.open('POST', WP_UPLOAD_ENDPOINT, true);

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              try {
                const res = JSON.parse(xhr.responseText);

                if (res && res.url) {
                  uploadedUrls.push(res.url);
                  updateLinksInput();

                  // 记录 URL
                  li.setAttribute('data-file-url', res.url);

                  // 成功状态
                  setProgress(li, 100);
                  setStatus(li, 'is-success');

                  // 关键功能：成功后删除进度条
                  const progressEl = li.querySelector('.file-item__progress');
                  if (progressEl) progressEl.remove();

                  resolve(res.url);
                } else {
                  setStatus(li, 'is-error');
                  reject(new Error('Invalid response'));
                }
              } catch (e) {
                setStatus(li, 'is-error');
                reject(e);
              }
            } else {
              setStatus(li, 'is-error');
              reject(new Error('Upload failed with HTTP ' + xhr.status));
            }
          }
        };

        xhr.upload.onprogress = function (event) {
          if (event.lengthComputable) {
            setProgress(li, Math.round((event.loaded / event.total) * 100));
          }
        };

        xhr.onerror = function () {
          setStatus(li, 'is-error');
          reject(new Error('Network error'));
        };

        const formData = new FormData();
        formData.append('file', file);
        xhr.send(formData);
      });
    }

    function handleFiles(files) {
      const currentCount = getCurrentCount();
      const remainingSlots = MAX_FILES - currentCount;

      if (remainingSlots <= 0) {
        updateDropzoneState();
        return;
      }

      const incoming = Array.from(files).slice(0, remainingSlots);

      incoming.forEach((file) => {
        uploadFile(file).catch(() => {});
      });
    }

    triggerBtn.addEventListener('click', () => {
      if (getCurrentCount() >= MAX_FILES) return;
      nativeInput.click();
    });

    nativeInput.addEventListener('change', (e) => {
      handleFiles(e.target.files);
      nativeInput.value = '';
    });

    // 拖拽
    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        if (getCurrentCount() < MAX_FILES) {
          dropzone.classList.add('file-dropzone--dragover');
        }
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        dropzone.classList.remove('file-dropzone--dragover');
      });
    });

    dropzone.addEventListener('drop', (e) => {
      if (getCurrentCount() >= MAX_FILES) return;
      handleFiles(e.dataTransfer.files);
    });

    updateDropzoneState();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-file-upload-wrapper]').forEach(initFileUploader);
  });

})();
